import Layout from '../components/Layout';

export default function Hidden() {
    return (
        <Layout>
            <h1 className="font-work">Hi I'm a hidden page!</h1>
        </Layout>
    );
}
